import { render, staticRenderFns } from "./TabSix.vue?vue&type=template&id=401d1840&scoped=true&"
import script from "./TabSix.vue?vue&type=script&lang=js&"
export * from "./TabSix.vue?vue&type=script&lang=js&"
import style0 from "./TabSix.vue?vue&type=style&index=0&id=401d1840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d1840",
  null
  
)

export default component.exports